<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getClient } from '@/services/clients/getClient'
import { getHistoricalByClient } from '@/services/historical/getHistoricalByClient'
import { getHistoricalByClientExcel } from '@/services/historical/getHistoricalByClientExcel'

export default {
  name: 'list-client-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 21,
      vuexnamespace: 'historicalClient',
      headerUrl: 'configurations/clients/details',
      detailResponsePath: 'Cliente',
      breadcrumbs: [],
      ExcelName: `${_.kebabCase(i18n.t('clients.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  mounted () {
    this.breadcrumbs = [
      { 
        url: this.role === 3 ? 'configurationssa' : 'configurations', 
        name: i18n.t('configurations.header') 
      },
      { url: 'configurations/clients', name: i18n.t('clients.header') },
      { paths: ['Nombre'] },
    ]
  },
  computed: { 
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  methods: {
    getParamsAux: function (data) {
      return { idCliente: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getClient(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByClientExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByClient(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
